<template>
  <vuex-table
    :fields="fields"
    :auto_start="false"
    :unstable_pagination="true"
    table_store="voice/stats/detailed"
  >
    <template #status="{ item }">
      <status-badge :value="item.status" />
    </template>
  </vuex-table>
</template>

<script>
  import StatusBadge from '@voice/components/calls-badge-state';
  import { mapGetters } from 'vuex';
  import { seconds_to_time } from '@shared/helpers/time';
  import { toUserDateWithTime } from '@shared/helpers/date_format';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: { StatusBadge },
    computed: {
      ...mapGetters('core/auth', ['user']),
      ...mapGetters('voice/stats/detailed', { items: DATA }),
      fields: function () {
        let headers;

        if (window.vc_enabled && this.user.id === 16) {
          headers = [
            {
              key: 'country',
              label: this.$t('voice.stats.detailed.field.country'),
              sortable: false,
              class: 'column-sticky',
              thStyle: {
                minWidth: '160px'
              }
            },

            {
              key: 'source_incoming',
              label: this.$t('voice.stats.detailed.field.source_incoming'),
              sortable: false,
              thStyle: {
                minWidth: '170px',
                maxWidth: '170px'
              }
            },

            {
              key: 'destination',
              label: this.$t('voice.stats.detailed.field.destination'),
              sortable: false,
              thStyle: {
                minWidth: '145px',
                maxWidth: '145px'
              }
            },

            {
              key: 'duration',
              label: this.$t('voice.stats.detailed.field.duration'),
              sortable: false,
              thStyle: {
                minWidth: '200px'
              },
              formatter: (value) => seconds_to_time(value)
            },

            {
              key: 'duration_billed',
              label: this.$t('voice.stats.detailed.field.duration_billed'),
              sortable: false,
              thStyle: {
                minWidth: '200px'
              },
              formatter: (value) => seconds_to_time(value)
            },

            {
              key: 'date',
              label: this.$t('voice.stats.detailed.field.date'),
              formatter: (value) => toUserDateWithTime(value),
              sortable: false,
              class: 'table-created_at'
            },

            {
              key: 'status',
              label: this.$t('shared.component.table.field.status'),
              sortable: false,
              thStyle: {
                minWidth: '120px'
              }
            },

            {
              key: 'call_type',
              label: this.$t('voice.stats.detailed.field.call_type'),
              sortable: false,
              thStyle: {
                maxWidth: '100px'
              },
              formatter: (value) => this.$t(`voice.call.type.${value}`)
            },

            {
              key: 'cost',
              label: this.$t('mailer.stats.general.field.cost'),
              sortable: false,
              thStyle: {
                minWidth: '130px'
              },
              formatter: (val) => this.$numeral.currency(val, this.user.currency)
            },
            {
              key: 'vc',
              label: 'Vendor cost',
              sortable: false,
              formatter: (val) => this.$numeral.currency(val, this.user.currency)
            }
          ];
        } else {
          headers = [
            {
              key: 'country',
              label: this.$t('voice.stats.detailed.field.country'),
              sortable: false,
              class: 'column-sticky',
              thStyle: {
                minWidth: '160px'
              }
            },

            {
              key: 'source_incoming',
              label: this.$t('voice.stats.detailed.field.source_incoming'),
              sortable: false,
              thStyle: {
                minWidth: '170px',
                maxWidth: '170px'
              }
            },

            {
              key: 'destination',
              label: this.$t('voice.stats.detailed.field.destination'),
              sortable: false,
              thStyle: {
                minWidth: '145px',
                maxWidth: '145px'
              }
            },

            {
              key: 'duration',
              label: this.$t('voice.stats.detailed.field.duration'),
              sortable: false,
              thStyle: {
                minWidth: '200px'
              },
              formatter: (value) => seconds_to_time(value)
            },

            {
              key: 'duration_billed',
              label: this.$t('voice.stats.detailed.field.duration_billed'),
              sortable: false,
              thStyle: {
                minWidth: '200px'
              },
              formatter: (value) => seconds_to_time(value)
            },

            {
              key: 'date',
              label: this.$t('voice.stats.detailed.field.date'),
              formatter: (value) => toUserDateWithTime(value),
              sortable: false,
              class: 'table-created_at'
            },

            {
              key: 'status',
              label: this.$t('shared.component.table.field.status'),
              sortable: false,
              thStyle: {
                minWidth: '120px'
              }
            },

            {
              key: 'call_type',
              label: this.$t('voice.stats.detailed.field.call_type'),
              sortable: false,
              thStyle: {
                maxWidth: '100px'
              },
              formatter: (value) => this.$t(`voice.call.type.${value}`)
            },

            {
              key: 'cost',
              label: this.$t('mailer.stats.general.field.cost'),
              sortable: false,
              thStyle: {
                minWidth: '130px'
              },
              formatter: (val) => {
                return this.$numeral.currency(val, this.user.currency);
              }
            }
          ];
        }

        const source_outgoing_key = {
          key: 'source_outgoing',
          label: this.$t('voice.stats.detailed.field.source_outgoing'),
          sortable: false,
          thStyle: {
            minWidth: '170px',
            maxWidth: '170px'
          }
        };

        const sameSources = this.items.filter((i) => i.source_incoming === i.source_outgoing);

        if (this.items.length > 0) {
          if (sameSources.length === this.items.length) {
            return headers.filter((i) => i.key !== 'source_outgoing');
          } else {
            let new_headers = headers;
            new_headers.splice(2, 0, source_outgoing_key);
            return new_headers;
          }
        } else {
          return headers;
        }
      }
    }
  };
</script>
